import React from 'react';
import Portal from '../Portal';

const CurrentPagePortal = ({ children }: any) => {
  const currentPage = document.getElementById('current-page');
  return currentPage ? <Portal element={currentPage}>{children}</Portal> : null;
};

export default CurrentPagePortal;
